import React from 'react';
import classNames from 'classnames';
import {
	SortableContainer,
	SortableElement,
	SortableHandle
} from 'react-sortable-hoc';
import Icon from '../Icon';

const DragHandle = SortableHandle(() => <Icon icon="arrows-x" />);

const Role = SortableElement(({ role, active, dragIndicator, onClick }) => {
	const roleClasses = classNames('role', {
		'role--active': active
	});

	const keysClasses = classNames('role__keys', {
		'role__keys--with-drag': dragIndicator
	});

	return (
		<div className={roleClasses} onClick={() => onClick(role)}>
			<div className="role__name">
				{role.name}
			</div>
			<div className={keysClasses}>
				{role.number_of_keys}
				<Icon icon="key" />
			</div>
			{dragIndicator &&
				<div className="role__drag">
					<DragHandle />
				</div>}
		</div>
	);
});

const RolesList = SortableContainer(
	({ roles = [], activeRoleId = {}, ...props }) =>
		<div className="roles-list">
			{roles.map((role, index) => {
				return (
					<Role
						{...props}
						key={role.role_id}
						index={index}
						role={role}
						active={role.role_id === activeRoleId}
					/>
				);
			})}
		</div>
);

const withSortableProps = ({ sortable, onSortEnd, ...props }) => {
	const sortableContainerProps = {
		axis: 'x',
		lockAxis: 'x',
		distance: '10',
		useDragHandle: true,
		shouldCancelStart: () => !sortable,
		onSortEnd
	};

	return (
		<RolesList
			{...props}
			{...sortableContainerProps}
			dragIndicator={sortable}
		/>
	);
};

export default withSortableProps;



// WEBPACK FOOTER //
// ./src/js/common/components/RolesList/RolesList.js